import {
  INTEGRATION_COMMUNITIES_REQUEST,
  INTEGRATION_COMMUNITIES_SUCCESS,
  INTEGRATION_COMMUNITIES_FAILURE,
  INTEGRATION_COMMUNITIES_UPDATE,
  UPDATE_NETWORK_BY_ID_SUCCESS,
} from '../actions/integration-communities';
import { SELECT_ORGANISATION } from '../../organisation/actions';
import type { CommunityGroup } from '../actions/integration-communities';

export type IntegrationCommunitiesState = {
  loading: boolean;
  error: string | null;
  data: CommunityGroup[];
};

const initialState: IntegrationCommunitiesState = {
  loading: false,
  error: null,
  data: [],
};

export default (state = initialState, action: any): IntegrationCommunitiesState => {
  switch (action.type) {
    case INTEGRATION_COMMUNITIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case INTEGRATION_COMMUNITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.data,
      };

    case INTEGRATION_COMMUNITIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case INTEGRATION_COMMUNITIES_UPDATE:
      return {
        ...state,
        data: action.data,
      };

    case UPDATE_NETWORK_BY_ID_SUCCESS:
      return {
        ...state,
        data: state.data.map((group) => {
          const updatedLinkedWith = group.linked_with.map((network) => {
            if (network.id === action.data.id) {
              return {
                ...network,
                external_id: action.data.external_id,
              };
            }
            return network;
          });

          return {
            ...group,
            linked_with: updatedLinkedWith,
          };
        }),
      };

    case SELECT_ORGANISATION:
      return initialState;

    default:
      return state;
  }
};
